import React from "react";
import { useCrewDefinitions } from "@/hooks/use-crew-definitions";
import { CapacityCalendar } from "../capacity-calendar";
import { CAPACITY_RESOURCE_CATEGORIES } from "../capacity-resource-categories";
import { CapacityPlannerCategoryRow } from "./capacity-planner-category-row";
import { CapacityPlannerCrewRows } from "./capacity-planner-crew-rows";

/**
 * The capacity board seen from the planner's side: one section per resource category the planning
 * works in, drawn on the same three-week window as the manager view. The categories are the
 * resources panel's own list, so the board and the panel never disagree about what a planner
 * schedules.
 *
 * Crews are the one category with entities behind them — the standing crews whose span reaches the
 * visible weeks. Every other category is its bar and nothing beneath it until its entities are
 * settled.
 */
export function CapacityPlannerView() {
	/** Query */
	const { crewDefinitions, isLoading } = useCrewDefinitions();

	/** Render */
	return (
		<CapacityCalendar isLoading={isLoading}>
			{CAPACITY_RESOURCE_CATEGORIES.map((category) => (
				<React.Fragment key={category.value}>
					<CapacityPlannerCategoryRow category={category} />
					{category.value === "crews" && (
						<CapacityPlannerCrewRows crewDefinitions={crewDefinitions} />
					)}
				</React.Fragment>
			))}
		</CapacityCalendar>
	);
}
